import { ControlItemValue, StaticControlItem } from '../../../../types/types';
import { PrefetchResult } from '../types';

type ProcessedPrefetchResult = {
  collected: Record<string, ControlItemValue>;
  optionsMap: Record<string, StaticControlItem[]>;
}

export const processPrefetchResults = (
  results: PrefetchResult[]
): ProcessedPrefetchResult => {
  const collected: Record<string, ControlItemValue> = {};
  const optionsMap: Record<string, StaticControlItem[]> = {};
  results.forEach((entry) => {
    if (entry) {
      collected[entry.name] = entry.defaultValue;
      optionsMap[entry.name] = entry.options;
    }
  });
  return { collected, optionsMap };
};
